import React, { useEffect, useState } from "react";
import ServicesTypeOne from "../services/services-one/ServicesTypeOne";
import SectionTitle from "../section-title/SectionTitle";

const HomeServices = () => {
  const [services, setServices] = useState(null);
  const [home, setHome] = useState(null);

  // console.log("services", services);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
         "https://portal.ebs365.info/api/sites/3/list/services"
        );
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);


  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
           "https://portal.ebs365.info/api/sites/3/pages/home"
        );
        const data = await response.json();
        setHome(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);

  let heroSection = null;
  if (home && home.data && home.data.sections) {
    heroSection = home.data.sections.find(
      (section) => section.title === "home_service"
    );
  }

  // console.log("g", heroSection);

  return (
    <div className="service2-sec pt-100 pb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <SectionTitle
              title="Our <span>Services</span> Here"
              content={heroSection && heroSection.items && heroSection.items[0] && heroSection.items[0].contents && heroSection.items[0].contents.subtitle ? heroSection.items[0].contents.subtitle : null}
            />
          </div>
        </div>
        <div className="row">
          {services && services.data && Array.isArray(services.data) ? (
            services.data.map((item) => (
              <ServicesTypeOne key={item.id} data={item} />
            ))
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default HomeServices;

